import { useTranslation } from "react-i18next";
import { array, boolean, number, object, string } from "yup";

export const MCPSettingSchema = () => {
    const { t } = useTranslation();

    return object().shape({
        enabled: boolean().required(),
        server_url: string().required(),
        max_tool_calls: number()
            .min(1, String(t("CH.MCP_MaxToolCallsRange")))
            .max(5, String(t("CH.MCP_MaxToolCallsRange")))
            .required(String(t("COMMON.Required_Input"))),
        tool_configs: array()
            .of(
                object().shape({
                    tool_name: string().required(),
                    enabled: boolean().required(),
                    display_name: string().required(String(t("COMMON.Required_Input"))),
                    timeout_seconds: number()
                        .min(1, String(t("CH.MCP_TimeoutRange")))
                        .max(30, String(t("CH.MCP_TimeoutRange")))
                        .required(String(t("COMMON.Required_Input"))),
                    custom_description: string().nullable(),
                    enabled_tools: array().of(string().required()).optional(),
                }),
            )
            .default([]),
        system_prompt_addon: string().default(""),
    });
};
